// extracted by mini-css-extract-plugin
export default {"root":"FullPageWrapper_root__VkxIl"};